export default (slots, requiredSlots, compName) => {
  requiredSlots.forEach((slotName) => {
    if (!slots[requiredSlots]) {
      console.error(
        `${compName} requires content to be provided in the slot: ${slotName}.`,
      )
    }
  })
}
